var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_121_1021)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 31,
    r: 31,
    fill: "#F9F9F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2208 15.2353C25.1417 17.3127 24 20.0712 24 23.017C24 29.079 28.9419 34 35.0085 34C37.9396 34 40.7002 32.8591 42.7792 30.7817C44.8582 28.7043 46 25.9458 46 23C46 16.9381 41.0581 12 34.9915 12C32.0604 12 29.2998 13.1409 27.2037 15.2183L27.2208 15.2353ZM43.086 23C43.086 25.1625 42.251 27.1889 40.7173 28.7214C39.1836 30.2539 37.1557 31.0882 35.0085 31.0882C30.5438 31.0882 26.914 27.4613 26.914 23C26.914 20.8375 27.749 18.8111 29.2827 17.2786C30.8164 15.7461 32.8443 14.9118 35.0085 14.9118C39.4733 14.9118 43.103 18.5387 43.103 23H43.086Z",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5855 34.3927C42.0739 33.9394 41.3148 33.907 40.7702 34.3118C40.7042 34.3603 34.4497 38.9745 28.6242 34.3118C28.0962 33.8908 27.3205 33.8908 26.8089 34.3442C26.5779 34.5384 21.132 39.2983 21 48.6076C21 48.98 21.1485 49.3362 21.4126 49.5952C21.6766 49.8543 22.0397 50 22.4192 50H46.5957C47.3548 50 47.9819 49.401 47.9984 48.6562C47.9984 48.2838 48.2459 39.4602 42.5855 34.3765V34.3927ZM23.888 47.2477C24.317 41.9697 26.6604 38.6507 27.8981 37.226C32.981 40.545 38.4433 38.9745 41.4468 37.1936C44.3183 40.3831 44.9784 44.9811 45.1434 47.2477H23.888Z",
    fill: "#2E7161"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_121_1021",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_1021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_1021",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1d28bf89823252fe5b2fcc271ac2f0be.svg";
export { ForwardRef as ReactComponent };